// extracted by mini-css-extract-plugin
export default {"welcome":"userInfo_welcome__1zi0G","centerText":"userInfo_centerText__Ri3C9"};